// src/components/dashboard/AdminSuggestionsTab.jsx
import React, { useState } from 'react';
import { suggestionService } from '../../services/api';
import { formatDate } from '../../utils/dateFormats';

export default function AdminSuggestionsTab({ data: suggestions, setData: setSuggestions, actionLoading, setActionLoading, setError }) {
    const [editingSuggestion, setEditingSuggestion] = useState(null);
    const [editText, setEditText] = useState('');

    const handleEdit = (suggestion) => {
        setEditingSuggestion(suggestion);
        setEditText(suggestion.text);
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        if (actionLoading || !editingSuggestion) return;
        setActionLoading(true);
        setError(null);

        try {
            const updated = { ...editingSuggestion, text: editText };
            const result = await suggestionService.updateSuggestion(editingSuggestion.id, updated);
            
            setSuggestions(prev => prev.map(s => s.id === editingSuggestion.id ? result.data || result : s));
            setEditingSuggestion(null);
        } catch (err) {
            setError('Error al actualizar la Sugerencia.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (actionLoading) return;
        if (!window.confirm('¿Confirmas la inactivación (eliminación) de esta Sugerencia?')) return;
        
        setActionLoading(true);
        setError(null);
        try {
            await suggestionService.deleteSuggestion(id); 
            setSuggestions(prev => prev.filter(s => s.id !== id));
        } catch (err) {
            setError('Error al inactivar la Sugerencia.');
        } finally {
            setActionLoading(false);
        }
    };

    return (
        <div className="mt-4">
            <h4 className="text-lg font-semibold mb-3">Gestión de Sugerencias ({suggestions.length})</h4>

            {editingSuggestion && (
                <form onSubmit={handleUpdate} className="mb-6 p-4 border rounded bg-yellow-50 space-y-3 max-w-2xl">
                    <h5 className="font-bold">Editar Sugerencia de: {editingSuggestion.createdBy}</h5>
                    <textarea 
                        value={editText} 
                        onChange={(e) => setEditText(e.target.value)} 
                        rows="4" 
                        required 
                        className="input-field" 
                        disabled={actionLoading} 
                    />
                    <div className="flex space-x-2">
                        <button type="submit" className="btn btn-primary" disabled={actionLoading}>{actionLoading ? 'Guardando...' : 'Guardar Cambios'}</button>
                        <button type="button" onClick={() => setEditingSuggestion(null)} className="btn btn-secondary" disabled={actionLoading}>Cancelar</button>
                    </div>
                </form>
            )}

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="table-th">Texto</th>
                            <th className="table-th">Creada por (ID)</th>
                            <th className="table-th">Fecha</th>
                            <th className="table-th">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {suggestions.map((s) => (
                            <tr key={s.id}>
                                <td className="table-td max-w-xs truncate">{s.text}</td>
                                <td className="table-td text-xs">{s.createdBy}</td>
                                <td className="table-td">{formatDate(s.createdAt)}</td>
                                <td className="table-td space-x-2">
                                    <button onClick={() => handleEdit(s)} className="text-[color:var(--primary)] hover:underline" disabled={actionLoading}>Editar</button>
                                    <button onClick={() => handleDelete(s.id)} className="text-red-600 hover:underline" disabled={actionLoading}>Eliminar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}